import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { FaRegCalendarAlt, FaUsers, FaSearch, FaRegTimesCircle, FaMinus, FaPlus, FaRegPlusSquare, FaBed, FaChevronDown, FaEdit, FaFilter } from "react-icons/fa";
import { Row, Col, Select, DatePicker, Card, Button, Input, Popover, Form, Drawer } from 'antd';
import "../hotel.scss"
import dayjs from 'dayjs';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { fetchHotelList } from '../../../redux/hotel/hotelListSlice';
import { fetchAllHotelList, fetchAllHotelPriceList } from '../../../redux/hotel/hotelsListSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { capitalizeWords, formatDate } from '../../../utils/Constants';
import HotelResultFilter from './HotelResultFilter';
import RoomSelectionPopoverContent from '../PaymentHotelpage/RoomSelectionPopoverContent';
import { fetchHotelCityContent } from '../../../redux/seo/cityHotelSlice';


const SearchBarResultHotel = () => {

    const [cityName, setcityName] = useState('');
    const [searchTerm, setSearchTerm] = useState(cityName);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [showSearchList, setShowSearchList] = useState(false);
    const [isVisibleMobile, setIsVisibleMobile] = useState(false);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
    const [open, setOpen] = useState(false);
    const hotelList = useSelector(state => state.hotel.hotelList);
    const dateFormat = 'MMM DD, YYYY';
    const popoverRef = useRef(null);
    const bannerSearch = useRef(null);
    let location = useLocation();


    useEffect(() => {
        const hotelData = localStorage.getItem('hotelSearchKey');
        if (hotelData) {
            const parsedData = JSON.parse(hotelData);
            setcityName(parsedData.name);
        }
    }, []);

    const showSearch = () => {
        setIsSearchVisible((prev) => !prev);
    };

    useEffect(() => {
        const handleResize = () => {
            const isMobile = window.innerWidth <= 768;
            setIsMobileView(isMobile);
            if (!isMobile) {
                setIsSearchVisible(false);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const getLocalStorageDate = (key, defaultValue = null) => {
        const value = localStorage.getItem(key);
        if (!value) {
            return defaultValue;
        }
        try {
            return JSON.parse(value);
        } catch (e) {
            console.error(`Error parsing localStorage key "${key}":`, e);
            return defaultValue;
        }
    };

    const today = dayjs().add(1, 'day').format(dateFormat);
    const nextDay = dayjs().add(2, "day").format(dateFormat);

    const getDate = {
        startDate: getLocalStorageDate("startDate", today),
        endDate: getLocalStorageDate("endDate", nextDay),
    };

    const [departureDate, setDepartureDate] = useState(getDate.startDate);
    const [returnDate, setReturnDate] = useState(getDate.endDate);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [isDatePickerOpenReturn, setIsDatePickerOpenReturn] = useState(false);
    const datePickerRef = useRef(null);
    const datePickerRefReturn = useRef(null);

    const disabledPastDate = (current) => {
        return current && current < moment().startOf("day");
    };

    const disabledReturnDate = (current) => {
        return (
            current &&
            (current < moment().startOf("day") || current < dayjs(departureDate).endOf("day"))
        );
    };

    const onChangeDeparture = (date, dateString) => {
        setDepartureDate(dateString);
        if (!returnDate || dayjs(dateString).isAfter(dayjs(returnDate))) {
            const updatedReturnDate = dayjs(dateString).add(1, "day").format(dateFormat);
            setReturnDate(updatedReturnDate);
        }
        setTimeout(() => {
            setIsDatePickerOpen(false);
            setIsDatePickerOpenReturn(true);
        }, 100);
    };

    const onChangeReturn = (date, dateString) => {
        setReturnDate(dateString);
        setIsDatePickerOpenReturn(false);
    };

    // const handleDatePickerClickOutside = useCallback((event) => {
    //     try {
    //         const isOutsideDatePicker = datePickerRef.current &&
    //             !datePickerRef.current.contains(event.target);
    //         const isOutsideDatePickerReturn = datePickerRefReturn.current &&
    //             !datePickerRefReturn.current.contains(event.target);

    //         if (isOutsideDatePicker && isOutsideDatePickerReturn) {
    //             setIsDatePickerOpen(false);
    //             setIsDatePickerOpenReturn(false);
    //         }
    //     }
    //     catch (error) {
    //         console.error("Date picker click handler error:", error);
    //     }
    // }, []);


    const handleDatePickerClickOutside = useCallback((event) => {
        try {
            const isOutsideDatePicker =
                datePickerRef.current instanceof HTMLElement &&
                !datePickerRef.current.contains(event.target);

            const isOutsideDatePickerReturn =
                datePickerRefReturn.current instanceof HTMLElement &&
                !datePickerRefReturn.current.contains(event.target);

            if (isOutsideDatePicker && isOutsideDatePickerReturn) {
                setIsDatePickerOpen(false);
                setIsDatePickerOpenReturn(false);
            }
        } catch (error) {
            console.error("Date picker click handler error:", error);
        }
    }, []);

    const handleSearchListClickOutside = useCallback((event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setShowSearchList(false);
        }
    }, []);

    const handleDivClick = useCallback(() => {
        setIsDatePickerOpen(true);
        setIsDatePickerOpenReturn(false);
    }, []);

    const handleDivClickReturn = useCallback(() => {
        setIsDatePickerOpenReturn(true);
        setIsDatePickerOpen(false);
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleDatePickerClickOutside);
        return () => document.removeEventListener('mousedown', handleDatePickerClickOutside);
    }, [handleDatePickerClickOutside]);

    useEffect(() => {
        document.addEventListener('mousedown', handleSearchListClickOutside);
        return () => document.removeEventListener('mousedown', handleSearchListClickOutside);
    }, [handleSearchListClickOutside]);

    useEffect(() => {
        setIsDatePickerOpen(false);
        setIsDatePickerOpenReturn(false);
    }, [returnDate]);


    const dispatch = useDispatch();


    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func(...args), delay);
        };
    };

    const delayedSearch = debounce((term) => {
        if (term.trim() !== "") {
            dispatch(fetchHotelList(term));
            setShowSearchList(true);
        }
    }, 1000);

    const handleInputChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        delayedSearch(term);
    }

    const handleSearchButtonClick = () => {
        setShowSearchList(true);
        delayedSearch(searchTerm);
    };

    const roomInfo = JSON.parse(localStorage.getItem('roomInfo')) || [
        { numberOfAdults: 1, numberOfChild: 0, childAge: [] }
    ];
    const [rooms, setRooms] = useState(roomInfo);
    const [toTalSelectRooms, setToTalSelectRooms] = useState(rooms);

    const addRoom = () => {
        if (rooms.length < 5) {
            setRooms([...rooms, { numberOfAdults: 1, numberOfChild: 0, childAge: [] }]);
        }
    };

    const removeRoom = (index, e) => {
        e.stopPropagation();
        if (rooms.length > 1) {
            setRooms(rooms.filter((_, i) => i !== index));
        }
    };

    const addAdults = (index) => {
        const updatedRooms = [...rooms];
        updatedRooms[index].numberOfAdults += 1;
        setRooms(updatedRooms);
    };

    const removeAdults = (index) => {
        const updatedRooms = [...rooms];
        if (updatedRooms[index].numberOfAdults > 1) {
            updatedRooms[index].numberOfAdults -= 1;
        }
        setRooms(updatedRooms);
    };

    const addChildren = (index) => {
        const updatedRooms = [...rooms];
        if (updatedRooms[index].numberOfChild < 3) {
            updatedRooms[index].numberOfChild += 1;
            updatedRooms[index].childAge.push(null);
        }
        setRooms(updatedRooms);
    };

    const removeChildren = (index) => {
        const updatedRooms = [...rooms];
        if (updatedRooms[index].numberOfChild > 0) {
            updatedRooms[index].numberOfChild -= 1;
            updatedRooms[index].childAge.pop();
        }
        setRooms(updatedRooms);
    };

    const onSelectChildAge = (value, roomIndex, childIndex) => {
        const updatedRooms = [...rooms];
        updatedRooms[roomIndex].childAge[childIndex] = value;
        setRooms(updatedRooms);
    };

    const applyChanges = () => {
        const roomInfo = rooms.map(room => ({
            numberOfAdults: room.numberOfAdults,
            numberOfChild: room.numberOfChild,
            childAge: room.childAge.filter(age => age !== null),
        }));
        setToTalSelectRooms(roomInfo)
        setOpen(false)
    };

    const totalAdults = rooms.reduce((total, room) => total + room.numberOfAdults, 0);
    const totalChildren = rooms.reduce((total, room) => total + room.numberOfChild, 0);
    const totalRooms = rooms.length;
    let navigate = useNavigate();

    const [tripjackCityId, setTripjackCityId] = useState("")
    const [countryId, setCountryId] = useState("");
    const [selectedHotelId, setSelectedHotelId] = useState("");
    const [isButtonClick, setIsButtonClick] = useState(false);
    const [selectedHotel, setSelectedHotel] = useState("");
    const [selectedCountryCode, setSelectedCountryCode] = useState("");
    const [countryName, setCountryName] = useState("");

    useEffect(() => {
        if (cityName) {
            setSearchTerm(cityName);
            dispatch(fetchHotelCityContent({ city: cityName }));
        }
    }, [cityName]);

    const extractCityFromUrl = () => {
        try {
            const pathSegments = location.pathname.split('/');
            const citySegment = pathSegments.find(segment => segment.startsWith('hotels-in-'));

            if (!citySegment) {
                throw new Error('City segment not found in URL.');
            }

            const citySlug = citySegment.replace('hotels-in-', ''); // e.g., "goa-velha"
            const cleanCity = citySlug.replace(/-/g, ' ');          // e.g., "goa velha"

            return { cleanCity };
        } catch (error) {
            console.error('Error parsing city from URL:', error);
            return { cleanCity: '' };
        }
    };

    useEffect(() => {
        const fetchCityCodes = async () => {
            try {
                const { cleanCity } = extractCityFromUrl();

                if (!cleanCity) {
                    console.warn('City could not be extracted from the URL.');
                    return;
                }

                const cityData = await dispatch(fetchHotelList(cleanCity)).unwrap();

                if (!cityData || cityData.length === 0) {
                    console.warn('No city data returned from API.');
                    return;
                }
                localStorage.setItem("hotelSearchKey", JSON.stringify({
                    'id': cityData[0]?.id,
                    'name': cityData[0]?.name,
                    'cityId': cityData[0]?.tboCityId,
                    'state': cityData[0]?.state,
                    'countryName': cityData[0]?.countryName,
                    'countryId': cityData[0]?.countryId,
                    'countryCode': cityData[0]?.tboCountryCode,
                    'source': cityData[0]?.source,
                    'tripjack_city_id': cityData[0]?.tripjack_city_id,
                }));
                setSelectedHotel(cityData[0]?.tboCityId || '');
                setSelectedCountryCode(cityData[0]?.tboCountryCode || '');
                setCountryName(cityData[0]?.countryName || '');
                setcityName(cityData[0]?.cityName || '');
                setCountryId(cityData[0]?.countryId || '');
                setSelectedHotelId(cityData[0]?.id || '');
                setTripjackCityId(cityData[0]?.tripjack_city_id || '');

            } catch (error) {
                console.error('Error fetching city codes:', error);
            }
        };

        fetchCityCodes();
    }, [dispatch]);


    const start_date = moment(departureDate);
    const end_date = moment(returnDate);
    const nightCount = end_date.diff(start_date, 'days');

    const fetchAllHotalRooms = () => {
        if (!selectedHotel || !selectedHotelId) {
            console.warn('Required data is missing. API will not be called.');
            return;
        }

        if (isButtonClick) {
            setIsButtonClick(false);
            return;
        }

        const reqBody = {
            checkinDate: dayjs(departureDate).format("YYYY-MM-DD"),
            checkoutDate: dayjs(returnDate).format("YYYY-MM-DD"),
            roomInfo: toTalSelectRooms,
            searchCriteria: {
                city: selectedHotelId,
                tboCityId: selectedHotel,
                tboCountryCode: selectedCountryCode,
                nationality: countryId,
                tripCityId: tripjackCityId
            },
        };

        //dispatch(fetchAllHotelList(reqBody));
        dispatch(fetchAllHotelList(reqBody)).then((res) => {
            if (res?.payload?.db == true) {
                dispatch(fetchAllHotelPriceList({ ...reqBody, hotelPrice: 'hotelPrice' }));
            }
        });
        localStorage.setItem("startDate", JSON.stringify(departureDate));
        localStorage.setItem("endDate", JSON.stringify(returnDate));
        localStorage.setItem("night", JSON.stringify(nightCount));
        localStorage.setItem("roomInfo", JSON.stringify(rooms));
        const formattedCity = cityName?.toLowerCase().replace(/\s+/g, '-');
        const formattedCountry = countryName?.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `hotels-in-${formattedCity}`;
        let resultUrl = `/hotels-${formattedCountry}/${urlIdDynamic}`
        navigate(resultUrl);
    };

    const [isHotelSelected, setIsHotelSelected] = useState(false);

    useEffect(() => {
        if ((selectedHotelId) || isHotelSelected) {
            fetchAllHotalRooms();
        }
    }, [selectedHotelId, selectedHotel, isHotelSelected]);

    const handleSelectHotel = (hotel) => {
        localStorage.setItem("hotelSearchKey", JSON.stringify({
            'id': hotel?.id,
            'name': hotel?.name,
            'cityId': hotel?.tboCityId,
            'state': hotel?.state,
            'countryName': hotel?.countryName,
            'countryId': hotel?.countryId,
            'countryCode': hotel?.tboCountryCode,
            'source': hotel?.source,
            'tripjack_city_id': hotel?.tripjack_city_id,
        }));
        setTripjackCityId(hotel?.tripjack_city_id)
        setSelectedHotel(hotel?.tboCityId || '');
        setSelectedCountryCode(hotel?.tboCountryCode || '');
        setCountryName(hotel?.countryName || '');
        setcityName(hotel?.cityName || '');
        setSelectedHotelId(hotel?.id || '');
        setCountryId(hotel?.countryId || '');
        setShowSearchList(false);
        setIsHotelSelected(true);
        setIsButtonClick(true);
    };

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isReturnDrawerOpen, setIsReturnDrawerOpen] = useState(false);
    const todayCurrent = moment();

    const generateCalendarRetrun = () => {
        const calendar = [];
        const endOfYear = todayCurrent.clone().add(1, "year").endOf("year");
        let current = todayCurrent.clone().startOf("month");

        while (current.isBefore(endOfYear, "month")) {
            const daysInMonth = current.daysInMonth();
            const startDay = current.clone().startOf("month").day();

            const monthData = {
                month: current.format("MMMM YYYY"),
                days: [],
            };

            for (let i = 0; i < startDay; i++) {
                monthData.days.push(null);
            }

            for (let day = 1; day <= daysInMonth; day++) {
                const date = current.clone().date(day);
                monthData.days.push(date);
            }

            calendar.push(monthData);
            current.add(1, "month");
        }

        return calendar;
    };

    const calendarData = generateCalendarRetrun();
    const handleDateSelect = (date) => {
        if (!date || date.isBefore(todayCurrent, "day")) return;
        setDepartureDate(date.format("YYYY-MM-DD"));
        setIsDrawerOpen(false);
        setReturnDate(date.format("YYYY-MM-DD"))
        setIsReturnDrawerOpen(true)
    };

    const handleReturnDateSelect = (date) => {
        const departureDateMoment = moment(departureDate, "YYYY-MM-DD");
        if (!date || !departureDateMoment || date.isBefore(departureDateMoment, "day")) {
            return;
        }
        setReturnDate(date.format("YYYY-MM-DD"));
        setIsReturnDrawerOpen(false);
    };

    const filteredCalendarData = calendarData.filter((month) => {
        const firstDate = month.days.find((date) => date);
        return firstDate && firstDate.isSameOrAfter(todayCurrent, "month");
    });

    const filteredReturnCalendarData = calendarData.filter((month) => {
        const firstDate = month.days.find((date) => date);
        const departureMoment = departureDate ? moment(departureDate, "YYYY-MM-DD") : null;
        return (
            firstDate &&
            departureMoment &&
            firstDate.isSameOrAfter(todayCurrent, "month")
        );
    });

    const departureDateDayjs = useMemo(() => {
        return departureDate ? dayjs(departureDate, dateFormat) : null;
    }, [departureDate, dateFormat]);

    const returnDateDayjs = useMemo(() => {
        return returnDate ? dayjs(returnDate, dateFormat) : null;
    }, [returnDate, dateFormat]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (showSearchList && inputRef.current) {
            inputRef.current.focus();
        }
    }, [showSearchList]);

    const [form] = Form.useForm();

    return (
        <>
            {isVisibleMobile && <HotelResultFilter setIsVisibleMobile={setIsVisibleMobile} />}
            <section className='hotel_search  hotel_search_result pt-0 mb-3'>
                <div ref={bannerSearch} className={`Banner_cntr mt-0 pt-0 ${isMobileView && !isSearchVisible ? 'd-none' : ''}`}>
                    <div className='container-fluid'>
                        <Row gutter={16} className='w-100 justify-content-center m-0 d-block'>
                            <Card className='hotel-result-update'>
                                <div className='container'>
                                    <Row gutter={16} className='align-items-center'>
                                        <Col lg={6} md={24} xs={24} className='from_to_box pe-md-1 mb-2 mb-lg-0'>
                                            <div className='hotel_destination' onClick={handleSearchButtonClick}>
                                                <label>
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" fill="#999999">
                                                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                                        <g id="SVGRepo_iconCarrier"> <defs> </defs> <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" sketch:type="MSPage"> <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-104.000000, -411.000000)" fill="#999999"> <path d="M116,426 C114.343,426 113,424.657 113,423 C113,421.343 114.343,420 116,420 C117.657,420 119,421.343 119,423 C119,424.657 117.657,426 116,426 L116,426 Z M116,418 C113.239,418 111,420.238 111,423 C111,425.762 113.239,428 116,428 C118.761,428 121,425.762 121,423 C121,420.238 118.761,418 116,418 L116,418 Z M116,440 C114.337,440.009 106,427.181 106,423 C106,417.478 110.477,413 116,413 C121.523,413 126,417.478 126,423 C126,427.125 117.637,440.009 116,440 L116,440 Z M116,411 C109.373,411 104,416.373 104,423 C104,428.018 114.005,443.011 116,443 C117.964,443.011 128,427.95 128,423 C128,416.373 122.627,411 116,411 L116,411 Z" id="location" sketch:type="MSShapeGroup"> </path> </g> </g> </g>
                                                    </svg>
                                                    Where </label>
                                                <button className='hotel_from-search-btn'
                                                    onClick={handleSearchButtonClick}
                                                    aria-label="city name"
                                                >
                                                    <span className='Hotel-select-title'>{capitalizeWords(cityName)}</span>
                                                </button>
                                            </div>

                                            {showSearchList && (
                                                <div ref={popoverRef} className='search-list-container'>
                                                    <Input ref={inputRef} style={{ height: "48px" }} size="large" className='mb-2' placeholder="Where do you want to stay ..." value={capitalizeWords(searchTerm)} onChange={handleInputChange} prefix={<FaSearch className='mx-1' />} />
                                                    <ul className='search-list my-2'>
                                                        <span className='mx23 text-uppercase'>City, Hotel name or Location</span>
                                                        {(hotelList?.map((hotel, index) => (
                                                            <li
                                                                key={index}
                                                                onClick={() => handleSelectHotel(hotel)}
                                                                className="hotel-list-item mt-2"
                                                            >
                                                                {hotel?.source == 'city' && (
                                                                    <div className="d-flex align-items-center">
                                                                        <span className="me-2 location-icon">
                                                                            <svg width="1em" height="1em" viewBox="-1.5 0 15 15" xmlns="http://www.w3.org/2000/svg" fill={hotel.countryName.toLowerCase() == 'india' ? '#20926d' : '#000000'}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill={hotel.countryName.toLowerCase() == 'india' ? '#20926d' : '#000000'} fillRule="evenodd" d="M574,120 C575.324428,120 580,114.054994 580,110.833333 C580,107.611672 577.313708,105 574,105 C570.686292,105 568,107.611672 568,110.833333 C568,114.054994 572.675572,120 574,120 Z M574,113.333333 C575.420161,113.333333 576.571429,112.214045 576.571429,110.833333 C576.571429,109.452621 575.420161,108.333333 574,108.333333 C572.579839,108.333333 571.428571,109.452621 571.428571,110.833333 C571.428571,112.214045 572.579839,113.333333 574,113.333333 Z" transform="translate(-568 -105)"></path> </g></svg>
                                                                        </span>
                                                                        <div className="d-flex justify-content-between align-items-center w-100">
                                                                            <span className={`airportTitle d-block ${hotel.countryName.toLowerCase()}`}>
                                                                                {hotel?.name.charAt(0).toUpperCase() +
                                                                                    hotel?.name.slice(1).toLowerCase()}
                                                                            </span>
                                                                            <span className={`airportSubTitle d-block ${hotel.countryName.toLowerCase()}`}>
                                                                                {hotel?.countryName.charAt(0).toUpperCase() +
                                                                                    hotel?.countryName.slice(1).toLowerCase()}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {hotel?.source == 'hotel' && (
                                                                    <div className="flight-details">
                                                                        <span className="icon">
                                                                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" transform="matrix(-1, 0, 0, 1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier">  <g id="Layer_Grid"></g> <g id="Layer_2"> <path d="M12.1,4.6L5.4,2.1C5,1.9,4.7,2,4.4,2.2C4.2,2.4,4,2.7,4,3v16c0,1.7,1.3,3,3,3h6h2h2c1.7,0,3-1.3,3-3v-4c0-1.7-1.3-3-3-3h-3 V7.4C14,6.1,13.2,5,12.1,4.6z M12,13v7h-2v-2.3c0-0.4-0.3-0.8-0.8-0.8H8.8C8.3,17,8,17.3,8,17.8V20H7c-0.6,0-1-0.4-1-1V4.4l5.4,2 C11.7,6.6,12,7,12,7.4V13z M17,14c0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1v-1.3c0-0.4-0.3-0.8-0.8-0.8h-0.5c-0.4,0-0.8,0.3-0.8,0.8V20 h-1v-6H17z"></path> <rect height="1" width="1" x="7" y="7"></rect> <rect height="1" width="1" x="8" y="12"></rect> <rect height="1" width="1" x="9" y="9"></rect> <rect height="1" width="1" x="10" y="14"></rect> <rect height="1" width="1" x="16" y="15"></rect> </g> </g></svg>
                                                                        </span>
                                                                        <div className="flight-info">
                                                                            <span className="airportTitle">
                                                                                {hotel?.name &&
                                                                                    (hotel.name.length > 30
                                                                                        ? hotel.name.slice(0, 23).charAt(0).toUpperCase() +
                                                                                        hotel.name.slice(1, 23).toLowerCase() +
                                                                                        '...'
                                                                                        : hotel.name.charAt(0).toUpperCase() + hotel.name.slice(1).toLowerCase())}
                                                                            </span><br />
                                                                            <span className="airportSubTitle">Hotel in {hotel?.name &&
                                                                                (hotel.cityName.charAt(0).toUpperCase() + hotel.cityName.slice(1).toLowerCase())},
                                                                                {hotel?.name && ((hotel.state.charAt(0).toUpperCase() || hotel.countryName.charAt(0).toUpperCase()) +
                                                                                    (hotel.state.slice(1).toLowerCase() || hotel.countryName.slice(1).toLowerCase()))}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </li>))
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                        </Col>

                                        <Col lg={8} md={12} xs={24} className=''>
                                            <Row className=''>

                                                <Col span={12} className="pe-1 d-none d-md-block" onClick={handleDivClick}>
                                                    <div className='checkin'>
                                                        <label><FaRegCalendarAlt /> Check In</label>
                                                        <DatePicker
                                                            ref={datePickerRef}
                                                            variant="bordered"
                                                            onChange={onChangeDeparture}
                                                            open={isDatePickerOpen}
                                                            value={departureDateDayjs}
                                                            format={dateFormat}
                                                            allowClear={false}
                                                            showNow={false}
                                                            disabledDate={disabledPastDate}
                                                            onOpenChange={(status) => setIsDatePickerOpen(status)}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col span={12} className="ps-1 d-none d-md-block">
                                                    <div className='checkout' onClick={handleDivClickReturn} >
                                                        <label><FaRegCalendarAlt /> Check Out</label>
                                                        <DatePicker
                                                            ref={datePickerRefReturn}
                                                            variant="bordered"
                                                            onChange={onChangeReturn}
                                                            open={isDatePickerOpenReturn}
                                                            value={returnDateDayjs}
                                                            format={dateFormat}
                                                            allowClear={false}
                                                            showNow={false}
                                                            disabledDate={disabledReturnDate}
                                                            onOpenChange={(status) => setIsDatePickerOpenReturn(status)}
                                                        />
                                                    </div>
                                                </Col>

                                                {/* mobile View */}
                                                {/* Departure Date Picker */}
                                                <Col span={12} className="pe-md-1 ps-md-1 w-100 pe-1 hide d-md-none">
                                                    <div
                                                        onClick={() => setIsDrawerOpen(true)}
                                                        className="open-calendar-btn select-date"
                                                    >
                                                        <div className='flight_from' style={{ cursor: 'pointer' }}>
                                                            <label className=''><FaRegCalendarAlt />  Check In</label>
                                                            <div>
                                                                {formatDate(departureDate)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Drawer
                                                        title="Check in"
                                                        placement="bottom"
                                                        onClose={() => setIsDrawerOpen(false)}
                                                        open={isDrawerOpen}
                                                        height="85vh"
                                                        // height="100vh"
                                                        className="calendar-drawer"
                                                        closeIcon={null}
                                                        styles={{ header: { textAlign: "right" } }}
                                                        extra={
                                                            <div
                                                                type="text"
                                                                onClick={() => setIsDrawerOpen(false)}
                                                                className="custom-close-icon mt-2"
                                                                style={{ color: "#fff" }}
                                                            >
                                                                <FaRegTimesCircle fontSize={25} />
                                                            </div>
                                                        }
                                                    >
                                                        <div className="calendar-container">
                                                            {filteredCalendarData.map((month, index) => (
                                                                <div key={index} className="month-section">
                                                                    <h4 className="month-title">{month.month}</h4>
                                                                    <div className="day-labels">
                                                                        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                                                            <div key={day} className="day-label">
                                                                                {day}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    <div className="dates-grid">
                                                                        {month.days.map((date, idx) => (
                                                                            <div
                                                                                key={idx}
                                                                                className={`date-cell ${!date
                                                                                    ? "empty"
                                                                                    : date.isBefore(todayCurrent, "day")
                                                                                        ? "disabled"
                                                                                        : date.isSame(moment(departureDate), "day")
                                                                                            ? "selected"
                                                                                            : ""
                                                                                    }`}
                                                                                onClick={() => handleDateSelect(date)}
                                                                            >
                                                                                {date ? (
                                                                                    <>
                                                                                        <div className="date">{date.format("D")}</div>
                                                                                    </>
                                                                                ) : null}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Drawer>

                                                </Col>

                                                <Col span={12} className="pe-md-1 ps-md-1 ps-1 w-100 hide d-md-none">
                                                    <div
                                                        onClick={() => setIsReturnDrawerOpen(true)}
                                                        className="select-date"
                                                    >

                                                        <div className="flight_from" style={{ cursor: 'pointer' }}>
                                                            <label><FaRegCalendarAlt />Check Out</label>

                                                            <>
                                                                <div
                                                                    onClick={() => setIsReturnDrawerOpen(true)}
                                                                    className="select-date"
                                                                >
                                                                    {/* {returnDate} */}
                                                                    {formatDate(returnDate)}
                                                                </div>
                                                            </>
                                                        </div>
                                                    </div>
                                                    <Drawer
                                                        title="Check Out"
                                                        placement="bottom"
                                                        onClose={() => setIsReturnDrawerOpen(false)}
                                                        open={isReturnDrawerOpen}
                                                        height="85vh"
                                                        className="calendar-drawer"
                                                        closeIcon={null}
                                                        styles={{ header: { textAlign: "right" } }}
                                                        extra={
                                                            <div
                                                                onClick={() => setIsReturnDrawerOpen(false)}
                                                                className="custom-close-icon mt-2"
                                                                style={{ color: '#fff' }}
                                                            >
                                                                <FaRegTimesCircle fontSize={25} />
                                                            </div>
                                                        }
                                                    >
                                                        <div className="calendar-container">
                                                            {filteredReturnCalendarData.map((month, index) => (
                                                                <div key={index} className="month-section">
                                                                    <h4 className="month-title">{month.month}</h4>
                                                                    <div className="day-labels">
                                                                        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                                                            <div key={day} className="day-label">{day}</div>
                                                                        ))}
                                                                    </div>
                                                                    <div className="dates-grid">
                                                                        {month.days.map((date, idx) => (
                                                                            <div
                                                                                key={idx}
                                                                                className={`date-cell ${!date
                                                                                    ? "empty"
                                                                                    : date.isBefore(moment(departureDate), "day")
                                                                                        ? "disabled"
                                                                                        : date.isSame(moment(returnDate), "day")
                                                                                            ? "selected"
                                                                                            : ""
                                                                                    }`}
                                                                                onClick={() => handleReturnDateSelect(date)}
                                                                            >
                                                                                <div className="date">{date?.format('D')}</div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Drawer>
                                                </Col>

                                            </Row>
                                        </Col>

                                        <Col lg={7} md={12} xs={24} className='ps-md-1'>
                                            <Popover
                                                content={
                                                    <RoomSelectionPopoverContent
                                                        rooms={rooms}
                                                        addRoom={addRoom}
                                                        removeRoom={removeRoom}
                                                        addAdults={addAdults}
                                                        removeAdults={removeAdults}
                                                        addChildren={addChildren}
                                                        removeChildren={removeChildren}
                                                        onSelectChildAge={onSelectChildAge}
                                                        applyChanges={applyChanges}
                                                        form={form}
                                                    />
                                                }
                                                placement="bottom"
                                                trigger="click"
                                                open={open}
                                                zIndexPopup="1030"
                                                onOpenChange={(visible) => setOpen(visible)}
                                            >
                                                <div className='flight_from'>
                                                    <span className='from-title'><FaUsers />  Room | Adult | Child  </span>

                                                    <div className="select-hotel">
                                                        {totalAdults} {totalAdults === 1 ? "Adult" : "Adults"}, {""}
                                                        <>
                                                            {totalRooms} {totalRooms === 1 ? "Room" : "Rooms"}, {" "}
                                                        </>
                                                        {totalChildren !== 0 && (
                                                            <>
                                                                {totalChildren} {totalChildren === 1 ? "Child" : "Children"}
                                                            </>
                                                        )}
                                                        <FaChevronDown />
                                                    </div>

                                                </div>
                                            </Popover>
                                        </Col>

                                        <Col lg={3} md={4} xs={24} className='text-center mt-2 mt-lg-0 d-flex align-items-center justify-content-between d-md-block'>
                                            <div>
                                                <Button
                                                    onClick={() => { fetchAllHotalRooms(); showSearch(); }}
                                                    className="ant-btn css-dev-only-do-not-override-1xg9z9n ant-btn-primary"
                                                    aria-label="Update"
                                                >
                                                    <span>Update</span>
                                                </Button>
                                            </div>
                                            <a onClick={showSearch} className="ms-2 fw-bold text-primary btn border-primary py-1 float-end d-md-none">
                                                Hide
                                            </a>
                                        </Col>

                                    </Row >
                                </div>
                            </Card >
                        </Row >
                    </div>
                </div>

                {isMobileView && !isSearchVisible && (
                    <div
                        className="result_hide_details m-auto pt-2 d-md-none"
                        style={{ width: '96%' }}
                    >
                        <div className="card mb-0 rounded">
                            <div className="card-body d-flex align-items-center gap-1 position-relative">
                                <div>
                                    <h4>{capitalizeWords(cityName)}</h4>
                                    <div className='d-flex align-items-center'>
                                        <p className='lh-sm'>{formatDate(departureDate)}</p> - <p className='lh-sm'>{formatDate(returnDate)}</p>
                                    </div>
                                </div>

                                <div className='mobile-result-button'>
                                    <a className="show-search-btn" onClick={showSearch}>
                                        <FaEdit className="down" />
                                    </a>

                                    <a className="show-search-btn" onClick={() => setIsVisibleMobile(true)}>
                                        <FaFilter className="down" />
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </section>
        </>
    )
}

export default SearchBarResultHotel